enum IvrSessionType {
  InitialIvrSession = 'INITIAL_IVR_SESSION',
  InitialOutgoingIvrSession = 'INITIAL_OUTGOING_IVR_SESSION',
  QueueIVRSession = 'QUEUE_IVR_SESSION',
  IVRAutomationSession = 'AUTOMATION',
}

class IvrSession {
  id: string;
  type: IvrSessionType;
  startTime: string;
  ivrId: string;
  ivrVersion: number;
  endpointAddress: string;
  customerAddress: string;
}

export default IvrSession;
